<template>
    <div>
        <div>
            <div>
                <el-row>
                    <div class="left-justifying"><h3>合同月账单</h3></div>
                    <div class="right-justifying">
                        <el-button type="info" plain size="small" @click="saveAdd" v-if="saveAddBtnExisted">
                            <i class="fa fa-save">
                            </i> 保存
                        </el-button>
                        <el-button type="info" plain size="small" @click="saveEdit" v-if="saveEditBtnExisted">
                            <i class="fa fa-save">
                            </i> 保存
                        </el-button>
                        <WorkflowRequestBtn
                            v-if="workflowBtnExisted" 
                            :visible="workflowBtnExisted" 
                            :use-new-api="true"
                            :bussiness="'CONTRACTBILL'"
                            :bussinessId="detail.data.id"
                            :bussinessInfo="workflowBussinessInfo"
                            :disabled="workflowBtnDisabled"
                            :is-can-send="isCanSendWorkflow"
                            @afterRequestWorkflowFunc="afterRequestWorkflowFunc"
                        >
                        </WorkflowRequestBtn>
                        <WorkflowReopenBtn 
                            v-if="workflowReopenBtnExisted"
                            :visible="workflowReopenBtnExisted" 
                            :use-new-api="true"
                            :bussiness="'CONTRACTBILL'"
                            :bussinessId="detail.data.id"
                            :bussinessInfo="workflowBussinessInfo"
                            :disabled="workflowReopenBtnDisabled"
                            @afterRequestWorkflowFunc="afterRequestWorkflowFunc"
                            :button-text="'变更'"
                        >
                        </WorkflowReopenBtn>
                    </div>
                </el-row>
            </div>
            <div class="panel">
                <div class="panel-body">
                    <el-row>
                        <div class="advanced-search-location">
                            <el-tag v-if="activeTabName !== 'list' && detail.data != null && detail.data.workflowStatus != null" type="danger" size="mini" style="margin-top: 9px;">
                            状态：<dictionary-text :factory-name="'domain'" :params="'CONTRACTBILLSTATUS'" :value="detail.data.workflowStatus"></dictionary-text>
                        </el-tag>
                        </div>
                        <el-tabs v-model="activeTabName" :before-leave="beforeLeave">
                            <el-tab-pane label="列表" name="list">
                                <contract-bill-month-list ref="list" :search="list.search">
                                </contract-bill-month-list>
                            </el-tab-pane>
                            <el-tab-pane label="详情" name="detail">
                                <contract-bill-month-detail ref="detailRef" @operation-change="onOperationChange" @curDetail="getCurDetail"  @curConfirmedDetail="getCurConfirmedDetail">
                                </contract-bill-month-detail>
                            </el-tab-pane>
                        </el-tabs>
                    </el-row>
                </div>
            </div>
        </div>
        <WorkflowDialog v-if="detail.data != null" ref="workflowDialog"
            :bussiness="'CONTRACTBILL'"
            :bussinessId="detail.data.id"
            :workflowRequestInfo="workflowRequestInfo"
            :dialogWorkflowVisible.sync="workflowDialogVisible"
            :status-name="'CONTRACTBILLSTATUS'"
            @afterAuditWorkflowFunc="afterAuditWorkflowFunc">
        </WorkflowDialog>
    </div>
</template>

<script>
    import {
        COMPONENT_MAIN,
        TAB_LIST,
        TAB_DETAIL, OPERATION_DETAIL_SHOW, OPERATION_DETAIL_ADD, OPERATION_DETAIL_EDIT,
        FN_SET_TAB, FN_SET_OPERATION,
        FN_LIST_QUERY, FN_TO_DETAIL_SHOW,
        PERMISSION_ADD, PERMISSION_EDIT, PERMISSION_DELETE
    } from './contract.bill.month.common'
    import ContractBillMonthList from './contract.bill.month.list'
    import ContractBillMonthDetail from './contract.bill.month.detail'
    import DictionaryText from "@/components/common/DictionaryText";
    import WorkflowDialog from '@/components/workflow/workflowDialog'
    import BillingServer from  '@/api/billing'
    import WorkflowRequestBtn from '@/components/workflow/workflowRequestBtn'
    import WorkflowReopenBtn from '@/components/workflow/workflowReopenBtn'

    export default {
        name: COMPONENT_MAIN,
        componentName: COMPONENT_MAIN,
        provide() {
            return {
                listQuery: this[FN_LIST_QUERY],
                toDetailShow: this.toShow,
                toDetailAdd: this.toAdd,
                toDetailEdit: this.toEdit,
                toDetailRemove: this.toRemove,
            };
        },
        components: {
            ContractBillMonthList,
            ContractBillMonthDetail, 
            WorkflowRequestBtn,
            WorkflowReopenBtn,
            WorkflowDialog,
            DictionaryText
        },
        data() {
            return {
                activeTabName: TAB_LIST,
                operation: null,
                list: {
                    search: {
                        cts_roomId: null,
                    },
                },
                detail: {
                    data: null
                },
                confirmDetail: {
                    data: null
                },
                workflowDialogVisible: false,
                workflowRequestInfo: {},
            };
        },
        watch: {
            activeTabName: {
                handler: function(val) {
                    if(val === 'list') {
                        this[FN_LIST_QUERY]();
                    }
                }
            }
        },
        computed: {
            workflowBussinessInfo() {
                let bussinessInfo = {};
                bussinessInfo.params = JSON.stringify({
                    CONTRACTBILLSTATUS: this.detail.data.workflowStatus
                });
                return bussinessInfo;
            },
            workflowBtnExisted() {
                return this.activeTabName === TAB_DETAIL && this.operation === OPERATION_DETAIL_SHOW && this.detail.data != null && !this.workflowReopenBtnExisted
            },
            workflowBtnDisabled() {
                return this.confirmDetail.data.status !== null && this.confirmDetail.data.status !== 0
            },
            workflowReopenBtnDisabled() {
                return this.confirmDetail.data.status !== null && this.confirmDetail.data.status !== 0
            },
            workflowReopenBtnExisted() {
                return this.activeTabName === TAB_DETAIL && this.operation === OPERATION_DETAIL_SHOW &&
                    this.detail.data != null
                     && this.detail.data.workflowStatus === 'CONFIRMED';
                },
                addBtnExisted() {
                return this.activeTabName === TAB_LIST && (PERMISSION_ADD == null || this.hasPermission(PERMISSION_ADD));
            },
            saveAddBtnExisted() {
                return this.activeTabName === TAB_DETAIL && this.operation === OPERATION_DETAIL_ADD &&
                    (PERMISSION_ADD == null || this.hasPermission(PERMISSION_ADD));
                },
                editBtnExisted() {
                return this.activeTabName === TAB_DETAIL && this.operation === OPERATION_DETAIL_SHOW &&
                    (PERMISSION_EDIT == null || this.hasPermission(PERMISSION_EDIT));
                },
                saveEditBtnExisted() {
                    return this.activeTabName === TAB_DETAIL && this.operation === OPERATION_DETAIL_EDIT &&
                    (PERMISSION_EDIT == null || this.hasPermission(PERMISSION_EDIT));
                },
            cancelEditBtnExisted() {
                return this.activeTabName === TAB_DETAIL && this.operation === OPERATION_DETAIL_EDIT &&
                (PERMISSION_EDIT == null || this.hasPermission(PERMISSION_EDIT));
            },
            deleteBtnExisted() {
                return this.activeTabName === TAB_DETAIL && this.operation === OPERATION_DETAIL_SHOW &&
                (PERMISSION_DELETE == null || this.hasPermission(PERMISSION_DELETE));
            },
        },
        methods: {
            doLook(id) {
                this.workflowNodeLogs = null;
                this.$refs['detailRef'].look(id);
            },
            isCanSendWorkflow() {
                return true
                // return this.detail.data.workflowStatus !== 'CONFIRMED'
            },
            async afterAuditWorkflowFunc(businessInfo) {
                console.log('businessInfo', businessInfo)
                let setValue = businessInfo.setValue == null ? null : JSON.parse(businessInfo.setValue);
                let op = setValue == null ? null : setValue.OP;
                
                let response;
                try {
                    response = await BillingServer.contractBillMonth.workflowAudit(businessInfo, {loading: true});
                } catch (error) {
                    let message = error.message;
                    if (error.response != null && error.response.data != null && error.response.data.message != null) {
                    message = error.response.data.message;
                    } else if (error.response != null && error.response.data != null && error.response.data.responseMessage != null) {
                    message = error.response.data.responseMessage;
                    }
                    this.$message.error(message);
                }
                if (response != null) {
                    if (String(response.data.code) === '200' || response.data.success) {
                    this.$refs.workflowDialog.close();
                    this.workflowDialogVisible = false;
                    this.$message.success('工作流发送成功！');
                    this.doLook(this.detail.data.id);
                    } else {
                    this.$message.error(response.data.responseMessage);
                    }
                }
            },
            afterRequestWorkflowFunc(a) {
                this.workflowDialogVisible = true;
                this.workflowRequestInfo = a;
            },
            getCurDetail(data) {
                this.detail.data = data
            },
            getCurConfirmedDetail(data) {
                this.confirmDetail.data = data
            },
            afterLoadWorkflowHistory(workflowNodeLogs) {
                this.workflowNodeLogs = workflowNodeLogs;
            },
            beforeLeave(tabName, oldTabName) {
                if (oldTabName === TAB_DETAIL && (this.operation === OPERATION_DETAIL_ADD || this.operation === OPERATION_DETAIL_EDIT)) {
                    return this.$confirm('您输入的数据未保存，确认离开吗？', '离开提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        return Promise.resolve();
                    }, () => {
                        return Promise.reject();
                    });
                }
                return Promise.resolve();
            },
            [FN_SET_TAB](tabName) {
                this.activeTabName = tabName;
            },
            [FN_SET_OPERATION](operation) {
                this.operation = operation;
            },
            [FN_TO_DETAIL_SHOW]() {
                this[FN_SET_TAB](TAB_DETAIL);
                this[FN_SET_OPERATION](OPERATION_DETAIL_SHOW);
            },
            [FN_LIST_QUERY]() {
                this.$refs['list'].query();
            },
            onOperationChange(operation) {
                this[FN_SET_OPERATION](operation);
            },
            getDetailComponent() {
                return this.$refs['detailRef'];
            },
            toShow(data) {
                this[FN_SET_TAB](TAB_DETAIL);
                this.getDetailComponent().toShow(data);
            },
            toAdd(data) {
                this[FN_SET_TAB](TAB_DETAIL);
                this[FN_SET_OPERATION](OPERATION_DETAIL_ADD);
                this.getDetailComponent().toAdd(data);
            },
            saveAdd() {
                this.getDetailComponent().saveAdd();
            },
            toEdit(data) {
                this[FN_SET_TAB](TAB_DETAIL);
                this.getDetailComponent().toEdit(data);
            },
            saveEdit() {
                this.getDetailComponent().saveEdit();
            },
            cancelEdit() {
                this.getDetailComponent().cancelEdit();
            },
            toRemove(data) {
                this.getDetailComponent().toRemove(data);
            }
        },
        created() {
            this.$on(FN_SET_TAB, (data) => {
                this[FN_SET_TAB](data);
            });
            this.$on(FN_SET_OPERATION, (data) => {
                this[FN_SET_OPERATION](data);
            });
            this.$on(FN_TO_DETAIL_SHOW, (data) => {
                this[FN_TO_DETAIL_SHOW](data);
            });
            this.$on(FN_LIST_QUERY, () => {
                this[FN_LIST_QUERY]();
            });
        },
        mounted() {
            setTimeout(() => {
                this[FN_LIST_QUERY]();
            });
        }
    }
</script>

<style scoped>

</style>
